const LoadingSpinnerComponent = () => (
  <div className="sid-spinner" data-testid="sid-spinner">
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
    <div className="sid-spinner__frame" />
  </div>
);

export { LoadingSpinnerComponent };
